<template>
    <div class="wy-interactions-phrase-categories">
      Coming soon...
    </div>
  </template>
  
  <script>
  import Vue from 'vue';
  
  export default Vue.extend({
    name: 'wy-interactions-phrase-categories',
  });
  </script>
  
  <style lang="scss">
 
  </style>